import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages } from '~src/codegen/Localize';

export function openDeleteDomainConfirmationDialog(deleteDomain: () => void) {
    const dialogInstance = openReactConfirmationDialog({
        title: Messages.dataConnectSiteSettingsDeleteDomain(),
        message: Messages.dataConnectSiteSettingsDeleteDomainConfirmation(),
        paramsForAction: {},
        actionName: Messages.confirm(),
        action: () => {
            deleteDomain();
            return Promise.resolve();
        },
        isActionDelete: true,
        dialogWidth: TabDialogWidth.width375px
    });

    return Promise.resolve(dialogInstance.result);
}
